import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tCompanies\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add Company", -1 /* HOISTED */);
const _hoisted_8 = { class: "form-contents" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "input-group-btn" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-8" };
const _hoisted_17 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_18 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_19 = { class: "float-end left5" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* HOISTED */);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix top10" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_22 = { class: "clearfix pad10" };
const _hoisted_23 = { class: "float-end" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_25 = {
    key: 0,
    class: "float-end"
};
const _hoisted_26 = { class: "float-end hidden-xs record-count" };
const _hoisted_27 = { class: "col-xs-12 col-sm-12" };
const _hoisted_28 = { class: "card bg-white data-grid companies-grid detached overflow-x-auto" };
const _hoisted_29 = { class: "table table-hover bottom0 pw100" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_31 = { key: 0 };
const _hoisted_32 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_33 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_34 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_35 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_36 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_37 = { class: "text-center hidden-sm" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_41 = { key: 0 };
const _hoisted_42 = { class: "clearfix visible-sm" };
const _hoisted_43 = { class: "clearfix" };
const _hoisted_44 = { class: "float-start right5" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-phone" }, null, -1 /* HOISTED */);
const _hoisted_46 = { class: "float-start" };
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-envelope-o" }, null, -1 /* HOISTED */);
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-map-marker" }, null, -1 /* HOISTED */);
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1 /* HOISTED */);
const _hoisted_50 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_51 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_52 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_53 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_54 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_55 = { key: 0 };
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "6"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_57 = [
    _hoisted_56
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (!_ctx.isClientAdministrator)
                        ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'company' }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_button, { variant: "primary" }, {
                                    default: _withCtx(() => [
                                        _hoisted_6,
                                        _hoisted_7
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [_directive_standard_or_higher]
                        ])
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_13, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_15)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_16, [
                        (_ctx.searchAttempted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_component_b_dropdown, {
                                            ref: "columnSettingsDropdown",
                                            "no-caret": "",
                                            end: "",
                                            sm: "",
                                            "auto-close": false,
                                            variant: "outline-secondary outline-secondary-pagination",
                                            disabled: _ctx.working
                                        }, {
                                            "button-content": _withCtx(() => [
                                                _hoisted_20
                                            ]),
                                            default: _withCtx(() => [
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_form_group, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    id: "includeDeleted",
                                                                    modelValue: _ctx.query.includeDeleted,
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue"])
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }),
                                                        _createTextVNode(),
                                                        _hoisted_21,
                                                        _createTextVNode(),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                            return (_openBlock(), _createBlock(_component_b_form_group, {
                                                                key: column.fieldName
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_group, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_b_form_checkbox, {
                                                                                id: column.fieldName,
                                                                                modelValue: column.visible,
                                                                                "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_divider),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_22, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createVNode(_component_b_button, {
                                                            variant: "secondary",
                                                            right: "",
                                                            sm: "",
                                                            onClick: _ctx.closeColumnSettingsMenu
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_24,
                                                                _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.numberOfVisibleColumns)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                            _createVNode(_component_b_pagination, {
                                                class: "float-end",
                                                modelValue: _ctx.query.pageNo,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                                                "per-page": _ctx.query.pageSize,
                                                "total-rows": _ctx.data.recordCount,
                                                "hide-ellipsis": true,
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_26, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("table", _hoisted_29, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _hoisted_30,
                                    _createTextVNode(),
                                    (_ctx.isVisible('companyName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CompanyName', title: 'Name' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('streetAddress3'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_32, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'StreetAddress3', title: 'City' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('streetAddress4'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_33, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'StreetAddress4', title: 'State' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('countryName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_34, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CountryName', title: 'Country' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('companyCode'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_35, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CompanyCode', title: 'Ref' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('accountCombinedStatus'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_36, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'AccountStatus', title: 'Account Status' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_37, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_38,
                                                                    _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _createTextVNode(),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.archive(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_39,
                                                                    _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                [_vShow, !_ctx.isClientAdministrator && !item.whenDeleted]
                                                            ]),
                                                            _createTextVNode(),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.restore(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_40,
                                                                    _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                [_vShow, !_ctx.isClientAdministrator && item.whenDeleted]
                                                            ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.isVisible('companyName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'company', params: { 'id': item.companyId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.companyName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_42, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'company', params: { 'id': item.companyId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.companyName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_43, [
                                                        _withDirectives(_createElementVNode("div", { class: "clearfix" }, _toDisplayString(item.companyTypeName), 513 /* TEXT, NEED_PATCH */), [
                                                            [_vShow, item.companyTypeName]
                                                        ]),
                                                        _createTextVNode(),
                                                        _withDirectives(_createElementVNode("div", null, [
                                                            _withDirectives(_createElementVNode("div", _hoisted_44, [
                                                                _hoisted_45,
                                                                _createTextVNode(" " + _toDisplayString(item.phone), 1 /* TEXT */)
                                                            ], 512 /* NEED_PATCH */), [
                                                                [_vShow, item.phone]
                                                            ]),
                                                            _createTextVNode(),
                                                            _createElementVNode("div", _hoisted_46, [
                                                                _withDirectives(_createElementVNode("span", null, [
                                                                    _hoisted_47,
                                                                    _createTextVNode(" " + _toDisplayString(item.emailAddress), 1 /* TEXT */)
                                                                ], 512 /* NEED_PATCH */), [
                                                                    [_vShow, item.email]
                                                                ])
                                                            ])
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vShow, item.phone || item.emailAddress]
                                                        ]),
                                                        _createTextVNode(),
                                                        _withDirectives(_createElementVNode("div", null, [
                                                            _hoisted_48,
                                                            _createTextVNode(" " + _toDisplayString(_ctx.getCombinedAddress(item)), 1 /* TEXT */)
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vShow, item.primaryAddressId]
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", null, [
                                                            _hoisted_49,
                                                            _createTextVNode(" " + _toDisplayString(_ctx.getAccountCombinedStatus(item)), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('streetAddress3'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(item.streetAddress3), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('streetAddress4'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_51, _toDisplayString(item.streetAddress4), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('countryName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_52, _toDisplayString(item.countryName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('companyCode'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_53, _toDisplayString(item.companyCode), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('accountCombinedStatus'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(_ctx.getAccountCombinedStatus(item)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_55, _hoisted_57))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
